import { MAX_SLOT_COLUMNS } from './computeSlotFrames';

export const DEFAULT_SLOT_ROW_COUNT = 3;

// The retailer leaflet this was built for: wide blocks while they fit, then the middle row
// splits first, then the outer rows. Any other grid packs top-down instead.
const THREE_ROW_DEFAULTS: number[][] = [
  [1, 0, 0],
  [1, 1, 0],
  [1, 1, 1],
  [1, 2, 1],
  [2, 1, 2],
  [2, 2, 2],
];

/** A rows table for every count up to `maxProducts`, each placing exactly its count. */
function defaultSlotRows(maxProducts: number, rowCount = DEFAULT_SLOT_ROW_COUNT): number[][] {
  return Array.from({ length: maxProducts }, (_, i) => {
    const count = i + 1;
    if (rowCount === THREE_ROW_DEFAULTS[0].length && count <= THREE_ROW_DEFAULTS.length) {
      return [...THREE_ROW_DEFAULTS[i]];
    }
    const rows = Array.from({ length: rowCount }, (_, row) => (row < count ? 1 : 0));
    let extra = count - Math.min(count, rowCount);
    for (let row = 0; extra > 0 && row < rowCount * MAX_SLOT_COLUMNS; row += 1) {
      const index = row % rowCount;
      if (rows[index] < MAX_SLOT_COLUMNS) {
        rows[index] += 1;
        extra -= 1;
      }
    }
    return rows;
  });
}

export default defaultSlotRows;
